// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.user.LeasingUserOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetInfoForObfuscatedUserWebApiResponseDto } from '../..';

interface GetInfoForUserParams {
  ouid: string;
}

export const LeasingUserOuidWebApiHandler_getInfoForUser_Path = '/api/web/v1/ouid/getInfoForUser';

/**
 * get lease and user info for obfuscated user string
 */
export const LeasingUserOuidWebApiHandler_getInfoForUser = (getParams: GetInfoForUserParams, client = getClient()) => {
  return httpFrontEndRequest<GetInfoForUserParams, never, GetInfoForObfuscatedUserWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserOuidWebApiHandler_getInfoForUser_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
